import React from 'react'
import moment from 'moment'

const FindTutorClassBannerCalendarHeader = ({ date }) => {
  return (
    <span className="text-xs text-center font-medium text-primary-100">
      {moment(date).format('ddd')}
    </span>
  )
}

export default FindTutorClassBannerCalendarHeader
